import { VREditorSubPanel } from '../subpanel.js';
import { Button, FieldLabel } from 'ca-ui';

export class VREditorBrandingPanel extends VREditorSubPanel {
  constructor (vr, editor) {
    super(vr, editor, {
      id: 'branding',
      name: 'Branding',
      allowAddAsset: false
    });
  }

  initControls () {
    if (this.vr.options.branding && this.vr.options.branding.logo) {
      this.logoThumbnail = $(`<img class='ca-vr_editorpanel_subpanel-branding_logothumbnail' src="${this.vr.options.branding && this.vr.options.branding.logo !== undefined ? this.vr.options.branding.logo : ''}"></img>`);
      super.append(this.logoThumbnail);
    } else {
      this.logoThumbnail = $('<img class=\'ca-vr_editorpanel_subpanel-branding_logothumbnail\' src=\'\'></img>');
      super.append(this.logoThumbnail);
    }
    this.logoContainer = new FieldLabel({ label: 'Logo' });
    super.append(this.logoContainer.el);

    this.chooseLogoButton = new Button({
      icon: 'photo-video',
      label: 'Change'
    });
    this.chooseLogoButton.on(
      'click',
      function () {
        this.vr.editor.openMediaPicker((data) => this.setLogo(data));
      }.bind(this)
    );
    this.logoContainer.setField(this.chooseLogoButton);
  }

  setLogo (data) {
    console.log(data.data);
    if (!this.vr.options.branding) {
      this.vr.options.branding = {
        logo: null
      };
    }
    if (data.data.url) {
      this.vr.options.branding.logo = data.data.url;
    } else {
      this.vr.options.branding.logo = data.url;
    }
    if (this.vr.clientLogo) {
      this.vr.clientLogo.attr('src', data.data.url);
      this.logoThumbnail.attr('src', data.data.url);
    } else {
      this.vr.clientLogo = $(`<img class="ca-vr_clientlogo" src="${data.data.url}">`);
      this.vr.container.append(this.vr.clientLogo);
    }
    this.vr.clientLogo.attr('src', data.data.url);
    this.logoThumbnail.attr('src', data.data.url);
  }

  openPanel () {}

  setObject (obj, fireAssetChange) {
    super.setObject(obj, fireAssetChange);
    if (obj) {
      this.logoThumbnail.show();
      this.logoContainer.show();
    } else {
      this.logoThumbnail.hide();
      this.logoContainer.hide();
    }
  }
}
